import { Offer_Activation_Operator } from '@occc/graphql';

import { OfferActivationFormValues } from '../../types';

export const offerActivationItems = [
  {
    title: 'Activated',
    value: Offer_Activation_Operator.IsActivated,
  },
  {
    title: 'Not Activated',
    value: Offer_Activation_Operator.IsNotActivated,
  },
];

export const offerActivationItemInitialValues: OfferActivationFormValues = {
  operator: Offer_Activation_Operator.IsActivated,
  targetOffer: undefined,
};
